import { getLocale } from "../runtime";

const sv_ficountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Finland`
};

const ficountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_ficountryenglish(inputs)
	return "fiCountryEnglish";
};

export { ficountryenglish as "fiCountryEnglish" };